
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import subscription_routes from "@/api/routes/subscriptions";

import ImageView from "@/components/ImageView.vue";
import AudioView from "@/components/audioView.vue";
import VideoView from "@/components/VideoView.vue";
import PdfView from "@/components/PdfView.vue";
import CFileDownload from "@/components/FileDownload.vue";

import SubscriptionUnit from "@/models/subscriptions/unit";
import EventVersion from "@/models/unit/unitable/event/version";

@Component({
  name: "CSubscriptionUnitEvent",
  components: {
    ImageView,
    AudioView,
    VideoView,
    PdfView,
    CFileDownload
  }
})
export default class CSubscriptionUnitEvent extends Vue {
  @Prop({ required: true }) protected subscription_unit!: SubscriptionUnit;
  @Prop({ required: true }) private is_current_user_subscription!: boolean;

  @Prop({ required: true }) protected program_id!: string;
  @Prop({ required: true }) protected unit_id!: string;

  public url: string | null = null;
  public url_file_type: string | null = null;
  public url_type: "image" | "video" | "audio" | "pdf" | null = null;

  public description: string = "";

  public event_agreed: boolean = false;
  public event_allowed: boolean = false;

  protected async created() {
    await this.changeEvent();
  }

  @Watch("subscription_unit")
  private async changeEvent() {
    const event = this.subscription_unit.unit_version.unitable as EventVersion;

    await this.eventWithTrainerAvailable();

    if (event.subordinate_description) {
      this.description = event.subordinate_description;
    }

    this.event_agreed = event.event_at != null;

    this.url = event.subordinate_url ? event.subordinate_url : null;
    this.url_file_type = event.subordinate_file_type
      ? event.subordinate_file_type
      : null;

    if (event.isSubordinateImage()) {
      this.url_type = "image";
    } else if (event.isSubordinateVideo()) {
      this.url_type = "video";
    } else if (event.isSubordinateVideo()) {
      this.url_type = "audio";
    } else if (event.isSubordinatePdf()) {
      this.url_type = "pdf";
    } else {
      this.url_type = null;
    }
  }

  private async eventWithTrainerAvailable() {
    return this.$api
      .get(subscription_routes.event_with_trainer_available(this.unit_id))
      .then(({ data: res }: { data: { match: boolean } }) => {
        this.event_allowed = res.match;
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }
}
